var _mask, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingsSummaryEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_239_3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.34865C2.11684 3.26958 6.24903 0.5 11 0.5C15.7509 0.5 19.8831 3.26959 21.9999 7.34865C19.8831 11.4277 15.7509 14.1973 11 14.1973C6.24903 14.1973 2.11684 11.4277 0 7.34865Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.34865L-1.06512 6.7959L-1.35196 7.34865L-1.06512 7.90139L0 7.34865ZM21.9999 7.34865L23.065 7.9014L23.3519 7.34865L23.065 6.79591L21.9999 7.34865ZM1.06512 7.90139C2.99324 4.18596 6.73415 1.7 11 1.7V-0.7C5.76391 -0.7 1.24043 2.3532 -1.06512 6.7959L1.06512 7.90139ZM11 1.7C15.2658 1.7 19.0067 4.18597 20.9348 7.9014L23.065 6.79591C20.7595 2.3532 16.236 -0.7 11 -0.7V1.7ZM20.9348 6.79591C19.0067 10.5113 15.2658 12.9973 11 12.9973V15.3973C16.236 15.3973 20.7595 12.3441 23.065 7.9014L20.9348 6.79591ZM11 12.9973C6.73415 12.9973 2.99324 10.5113 1.06512 6.7959L-1.06512 7.90139C1.24043 12.3441 5.76391 15.3973 11 15.3973V12.9973Z",
    fill: "black",
    mask: "url(#path-1-inside-1_239_3)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 7.5,
    r: 2.4,
    stroke: "black",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingsSummaryEye);
export default __webpack_public_path__ + "static/media/ratingsSummaryEye.9476baefcc6914f019b3fc90feef6f85.svg";
export { ForwardRef as ReactComponent };